// extracted by css-extract-rspack-plugin
var _1 = "UmfdZ";
export { _1 as "messageBar" }
